"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoDropDownBoxQuestionWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var journey_model_1 = require("@athena-portal/journey-model");
var FalconSelectQuestionWidgetBase_1 = require("../FalconSelectQuestionWidgetBase");
var InfoQuestionWrapper_1 = require("../../components/infoQuestion/InfoQuestionWrapper");
var InfoDropDownBoxQuestionWidget = /** @class */ (function (_super) {
    __extends(InfoDropDownBoxQuestionWidget, _super);
    function InfoDropDownBoxQuestionWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderInputField = function () {
            return ((0, jsx_runtime_1.jsx)("div", { className: "input-group", children: (0, jsx_runtime_1.jsxs)("select", { id: _this.props.question.name, className: "form-control ".concat(_this.getInputValidationClass()), onChange: _this.handleOnChangeEvent, onFocus: _this.executeNativeEvent, onBlur: _this.handleOnBlurEvent, onClick: _this.executeNativeEvent, onDoubleClick: _this.executeNativeEvent, disabled: _this.getSetting(InfoDropDownBoxQuestionWidget_1.inputDisabledSetting, false) || _this.isReadOnly(), value: _this.getValue(), children: [(0, jsx_runtime_1.jsx)("option", { value: '', children: _this.props.question.placeHolder ? _this.props.question.placeHolder : "Please select..." }), _this.state.lookupValues && _this.state.lookupValues.map(function (lookupItem) {
                            var className = lookupItem.value.replace(/ /g, '_').toLocaleLowerCase();
                            return ((0, jsx_runtime_1.jsx)("option", { className: className, value: lookupItem.id, children: _this.renderHtml(lookupItem.value) }, lookupItem.id));
                        })] }) }));
        };
        _this.getValue = function () {
            var interactionFieldValue = _this.bindFromField(_this.props.question.interactionField);
            if (interactionFieldValue === undefined || interactionFieldValue === null) {
                return "";
            }
            return interactionFieldValue;
        };
        return _this;
    }
    InfoDropDownBoxQuestionWidget_1 = InfoDropDownBoxQuestionWidget;
    InfoDropDownBoxQuestionWidget.prototype.render = function () {
        var label = this.props.question.label ? this.props.question.label : this.renderHtml(this.getSetting("labelHtml"));
        var info = this.renderHtml(this.getSetting("infoHtml") || "");
        return ((0, jsx_runtime_1.jsxs)(InfoQuestionWrapper_1.InfoQuestionWrapper, { label: label, infoType: this.getSetting("infoType"), info: info, infoTitle: this.getSetting("infoTitle"), className: this.getSetting("cssClass"), hideInfoButton: this.isMtaAndDisabled(), children: [this.renderInputField(), this.renderValidationResult()] }));
    };
    InfoDropDownBoxQuestionWidget.prototype.handleOnChangeEvent = function (event) {
        var type = event.type;
        this.bindToField(event);
        this.changelogRecorder.recordQuestion(type, this.props);
        this.executeNativeEvent(event);
    };
    var InfoDropDownBoxQuestionWidget_1;
    InfoDropDownBoxQuestionWidget.inputDisabledSetting = "inputDisabled";
    InfoDropDownBoxQuestionWidget = InfoDropDownBoxQuestionWidget_1 = __decorate([
        (0, journey_model_1.settings)([
            { name: "labelHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "infoType", type: journey_model_1.TypeDescriptions.String },
            { name: "infoTitle", type: journey_model_1.TypeDescriptions.String },
            { name: "infoHtml", type: journey_model_1.TypeDescriptions.String }
        ])
    ], InfoDropDownBoxQuestionWidget);
    return InfoDropDownBoxQuestionWidget;
}(FalconSelectQuestionWidgetBase_1.FalconSelectQuestionWidgetBase));
exports.InfoDropDownBoxQuestionWidget = InfoDropDownBoxQuestionWidget;
//# sourceMappingURL=InfoDropDownBoxQuestionWidget.js.map